//
// helpers/html-decode.js - decode html entities
//

function html_decode(str) {
  let el = document.createElement('div');
  el.innerHTML = str;
  return el.textContent;
}

module.exports = html_decode;
